import './SectionMainTitle.css';

function SectionMainTitle({title}) {
    return (
        <h2 className='section__title'>{title}</h2>
    );
}

export default SectionMainTitle;
